import { useState } from 'react';
import { WHATSAPP_CHAT_URL } from '../../config/contactLinks';
import PageLayout from '../../components/feature/PageLayout';
import PageHero from '../../components/feature/PageHero';
import FadeIn from '../../components/base/FadeIn';
import sssHero from '../../assets/images/hero-sss.jpg';

const faqs = [
  { q: 'Hangi bölgelere hizmet veriyorsunuz?', a: 'NiğPak Temizlik olarak Niğde Merkez ve çevresinde hizmet veriyoruz. İlçeler için bizimle iletişime geçin, size özel çözüm sunabiliriz.' },
  { q: 'Temizlik personeli güvenilir mi?', a: 'Tüm personelimiz güvenlik kontrolünden geçmiş, deneyimli ve eğitimli bireylerden oluşmaktadır. Ekibimiz ayrıca sigortalıdır.' },
  { q: 'Fiyatlar nasıl belirleniyor?', a: 'Fiyatlarımız temizlik alanının büyüklüğü, türü ve sıklığına göre belirlenmektedir. Ücretsiz keşif için WhatsApp\'tan bize ulaşabilirsiniz.' },
  { q: 'Malzeme ve ekipmanları siz mi getiriyorsunuz?', a: 'Evet, tüm profesyonel ekipman ve ürünleri biz sağlıyoruz. Çevre dostu ve sağlıklı ürünler kullanıyoruz.' },
  { q: 'İnşaat sonrası temizlik ne kadar sürer?', a: 'Binanın büyüklüğüne göre değişir. Ortalama bir daire için 4-6 saat, villa için 8-12 saat. Kesin süre için ücretsiz keşif yapıyoruz.' },
  { q: 'Koltuk ve halı yıkama nasıl yapılıyor?', a: 'Profesyonel buhar ve ekstraksiyon makinelerimizle derin temizlik yapılır. İşlem sonrası 4-6 saat kuruma süresi gerekir.' },
  { q: 'Aylık kontrat mümkün mü?', a: 'Evet! Apartman, ofis ve mağaza için haftalık/aylık kontratlarımız mevcuttur. Kontrat müşterilerimize özel fiyat ve öncelikli randevu sunuyoruz.' },
  { q: 'Randevu nasıl alınır?', a: 'WhatsApp (0543 191 0851) aracılığıyla randevu alabilirsiniz. 2 saat içinde geri dönüş garantisi veriyoruz.' },
  { q: 'Temizlik sırasında evde olmam gerekiyor mu?', a: 'Hayır, zorunlu değil. Güvenilir ekibimiz anahtarla da çalışabilir. Hizmet öncesi detayları görüşerek en uygun çözümü buluyoruz.' },
  { q: 'Temizlik sonrası memnun kalmazsam ne olur?', a: '%100 memnuniyet garantisi sunuyoruz. Eksik gördüğünüz bir alan varsa 24 saat içinde ücretsiz iade hizmeti veriyoruz.' },
];

export default function SSSPage() {
  const [openIdx, setOpenIdx] = useState<number | null>(null);

  return (
    <PageLayout>
      <PageHero
        label="SSS"
        title="Sık Sorulan Sorular"
        subtitle="Merak ettiğiniz her şey burada. Cevabını bulamadığınız soruları WhatsApp'tan sorabilirsiniz."
        bgImage={sssHero}
      />

      <section className="py-24 bg-white">
        <div className="max-w-3xl mx-auto px-4 md:px-8">
          <FadeIn className="mb-12">
            <div className="flex items-center gap-3 mb-4">
              <div className="w-8 h-[2px] bg-gold rounded-full" />
              <p className="text-gold text-[11px] font-bold uppercase tracking-[0.25em]">Merak Ettikleriniz</p>
            </div>
            <h2 className="text-4xl font-extrabold text-navy tracking-tight">Tüm Sorular</h2>
          </FadeIn>

          <div className="flex flex-col divide-y divide-gray-100">
            {faqs.map((faq, idx) => (
              <FadeIn key={idx} delay={idx * 0.04}>
                <div className="py-5">
                  <button
                    onClick={() => setOpenIdx(openIdx === idx ? null : idx)}
                    className="w-full flex items-center justify-between gap-4 text-left cursor-pointer group"
                  >
                    <span className={`font-bold text-sm transition-colors ${openIdx === idx ? 'text-gold' : 'text-navy group-hover:text-gold'}`}>
                      {faq.q}
                    </span>
                    <span className={`w-7 h-7 flex items-center justify-center rounded-lg shrink-0 transition-all ${openIdx === idx ? 'bg-gold text-white' : 'bg-[#f7f8fc] text-navy'}`}>
                      <i className={`${openIdx === idx ? 'ri-subtract-line' : 'ri-add-line'} text-sm`}></i>
                    </span>
                  </button>
                  {openIdx === idx && (
                    <p className="text-gray-400 text-sm leading-[1.9] mt-4 pr-12">{faq.a}</p>
                  )}
                </div>
              </FadeIn>
            ))}
          </div>

          <FadeIn className="mt-12">
            <div className="bg-[#f7f8fc] rounded-2xl p-7 flex flex-col sm:flex-row items-center justify-between gap-5">
              <div>
                <p className="font-bold text-navy text-sm mb-1">Sorunuz burada yoksa?</p>
                <p className="text-gray-400 text-xs">WhatsApp üzerinden bize doğrudan yazabilirsiniz.</p>
              </div>
              <a href={WHATSAPP_CHAT_URL} target="_blank" rel="nofollow noreferrer"
                className="flex items-center gap-2 bg-navy hover:bg-gold text-white font-bold px-6 py-3 rounded-lg text-sm transition-colors whitespace-nowrap cursor-pointer">
                <i className="ri-whatsapp-line text-base"></i>
                WhatsApp ile Sorun
              </a>
            </div>
          </FadeIn>
        </div>
      </section>
    </PageLayout>
  );
}
